<template lang="pug">
div
  UiCardSection
    UiStack
      UiStackItem(fill)
        .ui-card-section-title {{ $t("resellers.tabs.users") }}
      UiStackItem
        UiButton(
          variant="primary"
          @click="inviteNewUser"
          icon="Plus"
        ) {{ $t("resellers.invite_new_user") }}

  UiCardSection
    RestTable(
      namespace="reseller_users"
      :headers="headers"
      ref="resellersUsersTable"
      :fetch-handler="getData"
      embed
    )
      template(#cell:actions="{ item }")
        UiStack(spacing="xs")
          UiButton(
            size="sm"
            variant="smooth-primary"
            @click="editUser(item)"
            icon="PencilCreate"
          ) {{ $t("actions.edit") }}
          UiButton(
            size="sm"
            variant="smooth-danger"
            @click="deleteUser(item)"
            icon="Trash"
          ) {{ $t("actions.delete") }}

  EditUserModal(
    ref="EditUserModal"
    @done="reloadList"
  )
</template>

<script>
import router from "@/router";
import ApiResellers from "@/api/resellers.js";
import EditUserModal from "@/modals/Resellers/editUser.vue";

export default {
  components: {
    EditUserModal,
  },

  data() {
    return {
      headers: [
        {
          key: "id",
          label: "#",
          sortable: true,
          squeeze: true,
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
        },
        {
          key: "email",
          label: "email",
          sortable: true,
        },
        {
          key: "role",
          label: "role",
          sortable: true,
        },
        {
          key: "actions",
          label: "",
          squeeze: true,
        },
      ],
    };
  },

  methods: {
    reloadList() {
      this.$refs.resellersUsersTable.fetchData();
    },
    getData(params, config) {
      return ApiResellers.fetchResellerUsers(
        this.$route.params.id,
        params,
        config,
      ).then((resp) => {
        return {
          items: resp.data.reseller_users,
          meta: resp.data.meta,
        };
      });
    },

    editUser(item) {
      this.$refs.EditUserModal.open(this.$route.params.id, item);
    },

    deleteUser(item) {
      this.$dialogConfirm({
        title: this.$t("actions.remove"),
        description: this.$t("actions.confirm_remove"),
        variant: "danger",
        icon: "account-minus",
        okLabel: this.$t("actions.remove"),
        okVariant: "danger",
        okIcon: "Trash",
        cancelVariant: "smooth-secondary",
      }).then((result) => {
        if (!result) return;
        ApiResellers.deleteResellerUser(this.$route.params.id, item.id).then(
          (resp) => {
            this.reloadList();
          },
        );
      });
    },

    inviteNewUser() {
      this.$refs.EditUserModal.open(this.$route.params.id, null);
    },

    goBack() {
      router.push("/resellers");
    },
  },
};
</script>
